import styles from "./fileUpload.module.css";
import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import deleteIcon from "../../assets/images/delete.png"
import { Loader } from "../loader/Loader";
import FileUpload from "./AttachmentSection/attachmentSection";
import { getLogo } from "../../utils/constants/fileTypeLogo";

const FileUploadAttachment = ({ module ="" , note =true, isPreviewMode=false, ...props}) => {
    const { setFieldValue,acceptFileType,maxFileSize,combineFilesMaxSize,numOfFilesAllowToUpload,errorMessageForNumberOfFiles,maxFileSizeTXT,combineFilesMaxSizeTXT,displayMessage } = props;
    let [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');

    const { getRootProps, getInputProps, fileRejections } = useDropzone({
        multiple: true,
        accept: acceptFileType,
        onDrop: async (acceptedFiles) => {
            const maxSize = maxFileSize 
            const combineMaxSize = combineFilesMaxSize  

            if(files?.length + acceptedFiles?.length > numOfFilesAllowToUpload){
                setError(errorMessageForNumberOfFiles);
                return;
            }else{
                setError('');
            }

            for(const file of acceptedFiles){ // checking for file size
                if(maxSize){
                  if(file.size > maxSize){
                    setError(`File ${file.name} exceeds ${maxFileSizeTXT} limit`);
                    return 
                  }else{
                    setError('');
                  }
                }
                else{
                   setError('');
                }
            }

            let combinedSize = files?.reduce((acc, file) => acc + file.fileSize, 0);
            for(const file of acceptedFiles){ 
                combinedSize +=file.size;
            }
            if(combinedSize>combineMaxSize){
                setError(combineFilesMaxSizeTXT);
                return;
            }else{
                setError("");
            }
            for(const file of acceptedFiles){
                setUploading(true);
                let result = await props.upload({file});
                if(result.status){
                    let obj={
                        originalFileName:result.res?.originalFileName,
                        uniqueFileName:result.res?.uniqueFileName,
                        // fileSize : file.size
                    }
                    setFiles(files=[...files,obj]);
                    setFieldValue(props.name, files); 
                    setUploading(false);
                }else{
                    setUploading(false);
                    setError(`File ${file.name} have not been uploaded correctly`);
                }
            }
        },
        onFileDialogOpen:()=>{
            setError('');
        }
        ,onDropRejected:(rejectedFiles)=>{
            setError(`Only PDF files are supported. Please upload a document in .pdf format to continue.`);
        }
    });

    const removeFile = (file, index) => () => {
        const allFiles = [...files];
        allFiles.splice(index, 1)
        setFiles(allFiles);
        setFieldValue(props.name, allFiles);  
    }
    const thumbs = files?.map((file, index) => (
        <div className={styles.thumb} key={index}>
            <div className={styles.thumbInner}>
                <div className={styles.attachment}>
                    <img className={styles.preview}
                        src={getLogo(file?.originalFileName)}
                    />
                </div>
                <div key={index} title={file?.originalFileName} className={styles.fileName}>{file.originalFileName}</div>
                <div className={styles.deleteIcon}>
                    {!isPreviewMode&&
                    <img
                        src={deleteIcon}
                        onClick={removeFile(file, index)}
                    />}
                </div>
            </div>
        </div>
    ));

    const fileRejectionItems = fileRejections.map(({ file, errors }) => {
        return (
            <div className={styles.fileSizeError}>{file.path} {errors.map(e => e.message)}
            </div>
        )
    });
   

    useEffect(() => {
        if(props.value?.length==0 || props.value === null){  
            setFiles(files=[]);
            setError('')
        }else{
            setFiles(files=props.value); 
        }
    }, [props.value]);

    return (
        <React.Fragment>
            {note &&<div className={styles.message}><span className={styles.spannote}>Note: </span>Please do not upload any documents and files that contain <span className={styles.textstyle}>sensitive personal data</span> or <span className={styles.textstyle}>confidential information</span>.</div>}
            <div className={styles.thumbsContainer} id="thumbContainer">
                {thumbs}
                {/* {fileRejectionItems} */}
            </div>
            {uploading && <div><Loader style={styles.uploadLoader}/></div>}
            { error &&  <div className={styles.fileSizeError}>{error}</div>}
            <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                {!isPreviewMode&&
                <FileUpload displayMessage={displayMessage}/>}
            </div>
        </React.Fragment>
    );
}

export default FileUploadAttachment;

// *********************************************************

{/* <FileAttachment 
      setFieldValue={setFieldValue} 
      name={props.name} 
      value={value}

      displayMessage={"Each file can be up to 2 MB, with a maximum of 2 files allowed for upload."}
      maxFileSize = {2 * 1024 * 1024} //2MB
      maxFileSizeTXT={"2MB"}
      combineFilesMaxSize={3 * 1024 * 1024}
      combineFilesMaxSizeTXT={"Combined file size exceeds the 3MB limit"}
      numOfFilesAllowToUpload = {2}
      errorMessageForNumberOfFiles ={"You can upload max 2 files."}
      acceptFileType={ {    
        'image/*': ['.jpeg','.png',],
        'application/pdf': ['.pdf'],
        'application/vnd.ms-excel': ['.xls',],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
        'application/msword':['.doc'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
    }}   

/> */}